module.exports = __webpack_public_path__ + "img/GAME_WORDFERRISWHEEL1.aa443fff.jpg";